import { ErrorMessages } from '@/graphql/main';

const ACTION_ERRORS: string[] = [ErrorMessages.PasswordExpired, 'AUTH_NOT_AUTHENTICATED'];

export default ACTION_ERRORS;
